import React, { useEffect } from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import HeroSection from "../views/HeroSection";
import ViewVender from "../views/ViewVender";
import FormSection from "../views/FormSection";
import ViewProvaSocial from "../views/ViewProvaSocial";
import ViewDivulgacao from "../views/ViewDivulgacao";
import ViewTroca from "../views/ViewTroca";
import { useLocation } from "react-router-dom";
import Globais from "../components/Globais";
import '@fortawesome/fontawesome-free/css/all.min.css';



const Home: React.FC = () => {
  document.location.href = "https://www.multicotas.com.br";
  



  
  
  return( 
  <>
   
      
  </>
)};
export default Home;
